import { SpaceXxs, SpaceLg, FontSize100, ColorTextMedium, SizeIconSvgSm } from "@nxt-costco-com/forge-design-tokens";
const priceFullfillmentBoxStyles = {
  display: "flex",
  alignItems: "center",
  height: SpaceLg,
  gap: SpaceXxs,
  marginBottom: `-${SpaceXxs}`,
  // align with price
  zIndex: 3
  // if not applied user would click to the entire product tile, also the tooltip displays below the CTA button in some scenarios
};
const priceFullfillmentTextStyles = {
  marginTop: "1px",
  // fix small icon offset
  color: ColorTextMedium,
  fontSize: FontSize100
};
const priceIconStyles = {
  color: ColorTextMedium,
  height: SizeIconSvgSm,
  width: SizeIconSvgSm
};
const priceIconBtStyles = {
  display: "flex",
  gap: SpaceXxs,
  height: "100%",
  alignItems: "center"
};
export {
  priceFullfillmentBoxStyles,
  priceFullfillmentTextStyles,
  priceIconBtStyles,
  priceIconStyles
};
